import { type TOC } from '@ember/component/template-only';
import { concat, hash } from '@ember/helper';
import { eq } from 'ember-truth-helpers';
import DropdownDivider from './dropdown/divider.gts';
import DropdownButtonBase, {
  type Signature as DDBSignature
} from './dropdown-button-base.gts';

interface Signature {
  Element: DDBSignature['Element'];
  Blocks: {
    default: [
      {
        Item: DDBSignature['Blocks']['items'][0];
        Divider: typeof DropdownDivider;
      }
    ];
  };
  Args: {
    title: string;
    onClick?: (item?: string) => void;
    alignMenuLeft?: boolean;
    isLoading?: boolean;
    size?: 'tall' | 'normal';
  };
}

const DropdownButtonComponent: TOC<Signature> = <template>
  {{!
  @title - The title on the button.
  @onClick - An action which will be provided to every items. This action has the item name as parameter.
  @isLoading
}}
  <DropdownButtonBase
    @onClick={{@onClick}}
    @alignMenuLeft={{@alignMenuLeft}}
    ...attributes
  >

    <:button>
      <div class='ui buttons'>
        {{! prettier-ignore }}
        <div
        class={{concat "ui right labeled icon primary button [&.ui.right.labeled.icon.primary.button:not(.mini)]:uppercase [&.ui.right.labeled.icon.primary.button:not(.mini)]:leading-[1em] [&.ui.right.labeled.icon.primary.button]:!px-[3em]" (if @isLoading " disabled loading") (unless (eq @size "tall") " mini") }}
      >
        {{@title}}
        <i
          class="dropdown icon [.ui.labeled.icon.primary.button_&]:bg-transparent"
        ></i>
      </div>
      </div>
    </:button>

    {{! prettier-ignore }}
    <:items as |DropdownItem|>
    {{yield (hash Item=(component DropdownItem onClick=@onClick) Divider=DropdownDivider) }}
  </:items>
  </DropdownButtonBase>
</template>;

export default DropdownButtonComponent;
